// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SchemaTableListTreeMapQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
}>;

export type SchemaTableListTreeMapQuery = {
  __typename?: "GraphqlQuery";
  getSchemaTables: Array<{
    __typename?: "SchemaTable";
    id: string;
    schemaName: string;
    tableName: string;
    lastStats?: {
      __typename?: "SchemaTableInlineStats";
      dataSizeBytes?: number | null;
    } | null;
  }>;
};

export const SchemaTableListTreeMapDocument = gql`
  query SchemaTableListTreeMap($databaseId: ID!) {
    getSchemaTables(databaseId: $databaseId) {
      id
      schemaName
      tableName
      lastStats {
        dataSizeBytes
      }
    }
  }
`;

/**
 * __useSchemaTableListTreeMapQuery__
 *
 * To run a query within a React component, call `useSchemaTableListTreeMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaTableListTreeMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaTableListTreeMapQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useSchemaTableListTreeMapQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemaTableListTreeMapQuery,
    SchemaTableListTreeMapQueryVariables
  > &
    (
      | { variables: SchemaTableListTreeMapQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SchemaTableListTreeMapQuery,
    SchemaTableListTreeMapQueryVariables
  >(SchemaTableListTreeMapDocument, options);
}
export function useSchemaTableListTreeMapLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemaTableListTreeMapQuery,
    SchemaTableListTreeMapQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SchemaTableListTreeMapQuery,
    SchemaTableListTreeMapQueryVariables
  >(SchemaTableListTreeMapDocument, options);
}
// @ts-ignore
export function useSchemaTableListTreeMapSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemaTableListTreeMapQuery,
    SchemaTableListTreeMapQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemaTableListTreeMapQuery,
  SchemaTableListTreeMapQueryVariables
>;
export function useSchemaTableListTreeMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaTableListTreeMapQuery,
        SchemaTableListTreeMapQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemaTableListTreeMapQuery | undefined,
  SchemaTableListTreeMapQueryVariables
>;
export function useSchemaTableListTreeMapSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaTableListTreeMapQuery,
        SchemaTableListTreeMapQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SchemaTableListTreeMapQuery,
    SchemaTableListTreeMapQueryVariables
  >(SchemaTableListTreeMapDocument, options);
}
export type SchemaTableListTreeMapQueryHookResult = ReturnType<
  typeof useSchemaTableListTreeMapQuery
>;
export type SchemaTableListTreeMapLazyQueryHookResult = ReturnType<
  typeof useSchemaTableListTreeMapLazyQuery
>;
export type SchemaTableListTreeMapSuspenseQueryHookResult = ReturnType<
  typeof useSchemaTableListTreeMapSuspenseQuery
>;
export type SchemaTableListTreeMapQueryResult = Apollo.QueryResult<
  SchemaTableListTreeMapQuery,
  SchemaTableListTreeMapQueryVariables
>;
